import { SortType } from '@/enums/sort-type.enum';

export default (type: SortType): boolean =>
  // eslint-disable-next-line implicit-arrow-linebreak
  [SortType.CMS_ASC, SortType.DATE_ASC, SortType.TITLE_ASC].includes(type);
